export const API_URL = 'cmgf/v1/currencies';
export const NEW_CURRENCY_ARGS = {
	code: '',
	name: '',
	symbol_padding: '',
	symbol_left: '',
	symbol_right: '',
	thousand_separator: '',
	decimal_separator: '',
	decimals: 2,
};
